webpackJsonp([915738553496],{

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(38);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Privacy = function Privacy() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'Privacy Policy \u2013 Patr\xEDcia Marques'
	      ),
	      _react2.default.createElement('meta', { name: 'descritpion', value: 'Learn more about how I treat your privacy on my website.' })
	    ),
	    _react2.default.createElement(
	      'article',
	      {
	        className: (0, _emotion.css)({ padding: '60px 30px' })
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Privacy Policy'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Your privacy is very important to me. It is my policy to respect your privacy regarding any information that may be collected from you across this website, ',
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.patriciamarques.me' },
	          'http://www.patriciamarques.me'
	        ),
	        '.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I only ask for personal information when I truly need it to provide a service to you. I collect it by fair and lawful means, with your knowledge and consent. I also let you know why it is collected and how it will be used.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I only retain collected information for as long as necessary to provide you with your requested service. What data is stored, will be protected within commercially acceptable means to prevent loss and theft, as well as unauthorised access, disclosure, copying, use or modification.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'I don\u2019t share any personally identifying information publicly or with third-parties, except when required to by law.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'The website may link to external sites that are not operated by me. Please be aware that I have no control over the content and practices of these sites, and cannot accept responsibility or liability for their respective privacy policies.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'You are free to refuse the request for your personal information, with the understanding that I may be unable to provide you with some of your desired services.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Your continued use of the website will be regarded as acceptance of the practices around privacy and personal information. If you have any questions about how I handle user data and personal information, feel free to contact me.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Privacy Policy Changes'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Although most changes are likely to be minor, I may change this Privacy Policy from time to time. I encourage visitors to frequently check this page for any changes to this Privacy Policy. If I make changes, I will notify you by revising the change log below, and, in some cases, I may provide additional notice (such as adding a statement to the homepage or by sending you a notification through email). Your further use of the Services after a change to our Privacy Policy will be subject to the updated policy. That\u2019s it! Thanks for reading.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Change Log'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'First version of the Privacy Policy. ',
	          _react2.default.createElement(
	            'pre',
	            null,
	            '(20 August 2018)'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Privacy;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-js-67603e84499c69642fe9.js